// How a purchase order's statuses and line types wear the kit Tag. The colour is the meaning:
// each entry spreads straight onto <Tag>.

import { CATEGORY } from '../components/ui/categoryColors';
import type { TagProps } from '../components/ui/Tag';
import type { PoLineStatus, PoLineType, PoStatus } from './poApi';

export type PoTagLook = Pick<TagProps, 'tone' | 'hex'>;

export const PO_STATUS_TAG: Record<PoStatus, PoTagLook> = {
  draft: { tone: 'neutral' },
  pending_approval: { tone: 'warn' },
  submitted: { tone: 'info' },
  partially_received: { tone: 'accent' },
  received: { tone: 'good' },
  // The neutral mark, not its ink: a closed order recedes below a draft.
  closed: { hex: CATEGORY.neutral.mark.hex },
  cancelled: { tone: 'bad' },
};

export const PO_LINE_STATUS_TAG: Record<PoLineStatus, PoTagLook> = {
  pending: { tone: 'info' },
  partial: { tone: 'warn' },
  received: { tone: 'good' },
  cancelled: { tone: 'neutral' },
};

export const PO_LINE_TYPE_TAG: Record<PoLineType, PoTagLook> = {
  stock: { tone: 'neutral' },
  service: { hex: CATEGORY.indigo.ink.hex },
  charge: { hex: CATEGORY.teal.ink.hex },
};
